import { ColumnConfig } from '../../../molecules/table/columnSettings';

// Shipments Table Configuration
export const ANALYTICS_SHIPMENTS_STORAGE_KEY = 'analytics_shipments_column_visibility_v2';

export const ANALYTICS_SHIPMENTS_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'aggregateShipmentType', label: 'Type', isVisible: true },
  { id: 'shipmentNumber', label: 'Ship No.', isVisible: true, isLocked: true },
  { id: 'mbl', label: 'MBL/MAWB', isVisible: true },
  { id: 'serviceType', label: 'Service', isVisible: true },
  { id: 'date', label: 'Date', isVisible: true },
  { id: 'leadTime', label: 'Lead Time', isVisible: true },
  { id: 'invoiceNumber', label: 'Invoice No.', isVisible: true },
  { id: 'serviceProvider', label: 'Service Provider', isVisible: true },
  { id: 'modality', label: 'Modality', isVisible: true },
  { id: 'billedEntity', label: 'Billed Entity', isVisible: true },
  { id: 'invoiceAmountAfterTax', label: 'Invoice Amount', isVisible: true },
  { id: 'totalAmount', label: 'Total Amount', isVisible: true },
  { id: 'totalChargeAmountLeg1', label: 'Leg 1 Amount', isVisible: true },
  { id: 'totalChargeAmountLeg2', label: 'Leg 2 Amount', isVisible: true },
  { id: 'totalChargeAmountLeg3', label: 'Leg 3 Amount', isVisible: true },
  { id: 'pol', label: 'POL', isVisible: true },
  { id: 'pod', label: 'POD', isVisible: true },
  { id: 'grossWeight', label: 'Gross Weight', isVisible: true },
  { id: 'chargeableWeight', label: 'Chargeable Weight', isVisible: true },
  { id: 'shipmentChargesCount', label: 'Charges Count', isVisible: true },
  { id: 'volume', label: 'Volume', isVisible: true },
  { id: 'shipper', label: 'Shipper', isVisible: true },
  { id: 'shipperCountry', label: 'Shipper Country', isVisible: true },
  { id: 'consignee', label: 'Consignee', isVisible: true },
  { id: 'consigneeCountry', label: 'Consignee Country', isVisible: true },
  { id: 'goodsName', label: 'Goods Name', isVisible: true },
  { id: 'co2Emission', label: 'CO2 Emission', isVisible: true },
  { id: 'vehicleId', label: 'Vehicle ID', isVisible: true },
  { id: 'packageCount', label: 'Package Count', isVisible: true },
  { id: 'packageUnit', label: 'Package Unit', isVisible: true },
  { id: 'shipmentCurrentDeviationWorkflow', label: 'Deviation Workflow', isVisible: true },
  { id: 'shipmentStatus', label: 'Ship. Status', isVisible: true },
  { id: 'shipmentStatusReason', label: 'Reason for Ship. Status', isVisible: true },
  { id: 'actions', label: 'Actions', isVisible: true, isLocked: true },
];

// Invoices Table Configuration
export const ANALYTICS_INVOICES_STORAGE_KEY = 'analytics_invoices_column_visibility_v2';

export const ANALYTICS_INVOICES_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'aggregateShipmentType', label: 'Type', isVisible: true },
  { id: 'accountNumber', label: 'Account No.', isVisible: true },
  { id: 'invoiceNumber', label: 'Invoice No.', isVisible: true, isLocked: true },
  { id: 'date', label: 'Date', isVisible: true },
  { id: 'shipmentNumber', label: 'Shipment Count', isVisible: true },
  { id: 'invoiceChargesCount', label: 'Charges Count', isVisible: true },
  { id: 'billedEntity', label: 'Billed Entity', isVisible: true },
  { id: 'totalAmount', label: 'Total Amount', isVisible: true },
  { id: 'totalAmountInReferenceCurrency', label: 'Total Amount (Ref)', isVisible: true },
  { id: 'fapRef', label: 'FAP Ref', isVisible: true },
  { id: 'resolutionDate', label: 'Resolution Date', isVisible: true },
  { id: 'invoiceStatus', label: 'Status', isVisible: true },
  { id: 'reason', label: 'Reason', isVisible: true },
  { id: 'serviceProvider', label: 'Service Provider', isVisible: true },
  { id: 'modality', label: 'Modality', isVisible: true },
  { id: 'shipper', label: 'Shipper', isVisible: true },
  { id: 'pol', label: 'POL', isVisible: true },
  { id: 'shipperCountry', label: 'Shipper Country', isVisible: true },
  { id: 'consignee', label: 'Consignee', isVisible: true },
  { id: 'pod', label: 'POD', isVisible: true },
  { id: 'consigneeCountry', label: 'Consignee Country', isVisible: true },
  { id: 'actions', label: 'Actions', isVisible: true, isLocked: true },
];

// Charges Table Configuration
export const ANALYTICS_CHARGES_STORAGE_KEY = 'analytics_charges_column_visibility_v2';

export const ANALYTICS_CHARGES_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'aggregateShipmentType', label: 'Type', isVisible: true },
  { id: 'shipmentNumber', label: 'Ship No.', isVisible: true },
  { id: 'invoiceNumber', label: 'Invoice No.', isVisible: true, isLocked: true },
  { id: 'invoiceDate', label: 'Invoice Date', isVisible: true },
  { id: 'chargeDomain', label: 'Charge Domain', isVisible: true },
  { id: 'chargeName', label: 'Charge Name', isVisible: true },
  { id: 'chargeAmount', label: 'Charge Amount', isVisible: true },
  { id: 'chargeQuantity', label: 'Quantity', isVisible: true },
  { id: 'chargeUnitPrice', label: 'Unit Price', isVisible: true },
  { id: 'exchangeRate', label: 'Exchange Rate', isVisible: true },
  { id: 'serviceProvider', label: 'Service Provider', isVisible: true },
  { id: 'modality', label: 'Modality', isVisible: true },
  { id: 'pol', label: 'POL', isVisible: true },
  { id: 'pod', label: 'POD', isVisible: true },
  { id: 'legType', label: 'Leg Type', isVisible: true },
  { id: 'billedEntity', label: 'Billed Entity', isVisible: true },
  { id: 'deviationAmountInInvoiceCurrency', label: 'Deviation Amount', isVisible: true },
  { id: 'chargeAmountInInvoiceCurrency', label: 'Amount (Invoice Currency)', isVisible: true },
  { id: 'chargeAmountInReferenceCurrency', label: 'Amount (Ref Currency)', isVisible: true },
  { id: 'quantityUnit', label: 'Quantity Unit', isVisible: true },
  { id: 'chargeStatus', label: 'Charge Status', isVisible: true },
  { id: 'chargeStatusReason', label: 'Charge Status Reason', isVisible: true },
  { id: 'date', label: 'Date', isVisible: true },
  { id: 'actions', label: 'Actions', isVisible: true, isLocked: true },
];
